import $ from 'jquery';
import 'foundation-sites';
import '../styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './helpers/fontawesome';
import profileCardsLoadMore from './components/profileCardsLoadMore';



// Replacing the global clobbers plugins registered on WP's jQuery
// (Gravity Forms' maskedinput) — carry them over first
const wpjQuery = window.jQuery;
window.$ = window.jQuery = $;
if (wpjQuery && wpjQuery !== $) {
  ['mask', 'unmask'].forEach((fn) => {
    if (wpjQuery.fn[fn] && !$.fn[fn]) $.fn[fn] = wpjQuery.fn[fn];
  });
}

$(document).ready(function () {
  $(document).foundation();

  profileCardsLoadMore();

  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    $('.top-bar').toggleClass('open');
  });

  // Hero background video play/pause toggle
  $('.block-hero__video-toggle').on('click', function () {
    const video = $('.block-hero__video').get(0);
    if (!video) return;
    const $btn = $(this);

    if (video.paused) {
      video.play();
      $btn.removeClass('is-paused').addClass('is-playing').attr('aria-label', 'Pause background video');
    } else {
      video.pause();
      $btn.removeClass('is-playing').addClass('is-paused').attr('aria-label', 'Play background video');
    }
  });

  function addToggleAtBreakpoint() {
    if ($(window).width() <= 1024) {
      $('.menu li.menu-item-has-children').each(function () {
        if ($(this).find('.submenu-toggle').length === 0) {
          $(this).append('<span class="submenu-toggle"></span>');
        }
      });
    } else {
      $('.menu li.menu-item-has-children .submenu-toggle').hide();
    }
  }

  // Run on page load
  addToggleAtBreakpoint();

  // Run on window resize
  $(window).on('resize', function () {
    addToggleAtBreakpoint();
  });

  $('.top-bar').on('click', '.submenu-toggle', function () {
    $(this).toggleClass('open');
    $(this).parent().toggleClass('sub-active');
    $(this).prev().slideToggle();

    if ($('.submenu-toggle').hasClass('open')) {
      $('.top-bar').addClass('mob-overflow');
    } else {
      $('.top-bar').removeClass('mob-overflow');
    }
  });

  const $topBar = $('.top-bar');

  // Reset all submenus
  function resetSubmenus() {
    $topBar.find('li.parent').removeClass('keyboard-open');
    $topBar.find('.sub-menu').removeClass('visible').attr('aria-hidden', 'true');
    $topBar.find('.sub-menu a').attr('tabindex', '-1');
  }

  // Initial setup
  resetSubmenus();

  // Open submenu on keyboard (Enter or Space)
  $topBar.on('keydown', 'li.parent > a', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const $parent = $(this).parent();
      const $submenu = $parent.find('.sub-menu');

      const isOpen = $parent.hasClass('keyboard-open');

      resetSubmenus(); // close all others first

      if (!isOpen) {
        $parent.addClass('keyboard-open');
        $submenu.addClass('visible').attr('aria-hidden', 'false');
        $submenu.find('a').attr('tabindex', '0');
      }
    }
  });

  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        offset: 160,               // Trigger slightly sooner
        duration: 1000,             // Shorter duration = faster animation
        easing: 'ease-in-out-back',   // Smoother, softer exit curve
      });
    }
  }

  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  }, 500); // gives slick time to stabilize layout


  // Global smooth scroll for all anchor links
  // Skip Foundation's own data-open/data-close triggers and bare # hrefs
  $(document).on('click', 'a[href^="#"]', function (e) {
    const href = $(this).attr('href');
    if (!href || href === '#') return;
    const $target = $(href);
    if (!$target.length) return;
    e.preventDefault();
    const stickyOffset = $('.sticky.is-stuck').outerHeight() || 0;
    const scrollTop = $target.offset().top - stickyOffset - 16;
    $('html, body').animate({ scrollTop }, 550);
    history.pushState(null, '', href);
  });

  initAOS();

});
